<template>
  <div class="font-14">
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">報告・承認</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="card serach-form">
        <div class="card-header toggle-mark">
          <a data-toggle="collapse" href="#search-div">検索条件</a>
        </div>
        <div class="collapse show" id="search-div">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">事業所</label>
                  <select-office id="select-office" v-model="inputs.targetOfficeId" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">予定日時</label>
                  <div class="input-group">
                    <input id="start-day-from" class="form-control" type="date" v-model="inputs.startDayFrom">
                    <div style="line-height: 38px;">〜</div>
                    <input id="start-day-to" class="form-control" type="date" v-model="inputs.startDayTo">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">利用者(前方一致)</label>
                  <input type="text" class="form-control" v-model="inputs.userDisplayName" maxlength="64" />
                </div>
              </div>
              <div class="col-md-9">
                <div class="form-group">
                  <label class="control-label">サービスコード</label>
                  <div class="input-group">
                    <select-service-type name="service_type" v-model="inputs.serviceTypeId" v-validate="'required'"
                      data-vv-as="サービス種別" data-vv-validate-on="none" />
                    <template v-if="isSakura">
                      <select-service-code v-if="inputs.serviceTypeId !== Number(serviceTypeIdUniqueCode)"
                        :service-type-id="inputs.serviceTypeId" :target-date="inputs.startDayFrom"
                        :filter-by-addition="false"
                        v-model="inputs.serviceCodeId" />
                      <select-service-unique-code v-else :service-type-id="inputs.serviceTypeId"
                        v-model="inputs.serviceUniqueCodeId" />
                    </template>
                    <template v-else-if="isTeresaStandard">
                      <select-service-code v-if="inputs.serviceTypeId !== Number(serviceTypeIdUniqueCode)"
                        :service-type-id="inputs.serviceTypeId"
                        :specific-office-addition-cd="inputs.specific_office_addition_cd"
                        :target-date="inputs.startDayFrom" v-model="inputs.serviceCodeId" />
                      <select-service-teresa-unique-code v-else :service-type-id="inputs.serviceTypeId"
                        v-model="inputs.serviceTeresaUniqueCodeId" />
                    </template>
                    <template v-else>
                      <template v-if="isNativeCode">
                        <select-service-code v-if="inputs.serviceTypeId !== Number(serviceTypeIdUniqueCode)"
                          :service-type-id="inputs.serviceTypeId" :target-date="inputs.startDayFrom"
                          v-model="inputs.serviceCodeId" />
                        <select-service-teresa-unique-code v-else :service-type-id="inputs.serviceTypeId"
                          v-model="inputs.serviceTeresaUniqueCodeId" />
                      </template>
                      <template v-else>
                        <select-service-code :service-type-id="inputs.serviceTypeId" :target-date="inputs.startDayFrom"
                          v-model="inputs.serviceCodeId" />
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">スタッフ(前方一致)</label>
                  <input type="text" class="form-control" v-model="inputs.staffDisplayName" maxlength="64" />
                </div>
              </div>
            </div>
            <div class="row form-actions pb-3" v-if="isF1">
              <div class="col-md-6 text-right">
              </div>
              <div class="col-md-4 text-right">
                <button type="button" class="btn btn-block btn-secondary" :disabled="isProcessing"
                  @click.prevent="downloadF1Csv">
                  <span class="fa fa-download mr-1"></span>実施記録取得(ケアマネっ子)
                </button>
              </div>
            </div>
            <div class="row form-actions pb-3" v-if="isKaigoNoMori">
              <div class="col-md-6 text-right">
              </div>
              <div class="col-md-4 text-right">
                <button type="submit" class="btn btn-block btn-secondary" :disabled="isProcessing"
                  @click.prevent="downloadKaigoNoMoriCsv">
                  <span class="fa fa-download mr-1"></span>実施記録取得(介護の森)
                </button>
              </div>
            </div>
            <div class="row form-actions">
              <div class="col-md-6 text-right">
                <input id="display-data" class="form-control" type="radio" name="display_mode" :value="2"
                  v-model="inputs.mode">
                <label for="display-data">詳細情報を隠す</label>

                <input id="display-comment" class="form-control" type="radio" name="display_mode" :value="1"
                  v-model="inputs.mode">
                <label for="display-comment">詳細情報を表示する</label>

              </div>
              <div class="col-md-2 text-right">
                <button type="submit" class="btn btn-block btn-secondary" :disabled="isProcessing" @click="downloadCsv">
                  <span class="fa fa-download mr-1"></span>ダウンロード
                </button>
              </div>
              <div class="col-md-2 text-right">
                <button type="submit" class="btn btn-block btn-secondary" :disabled="isProcessing" @click="clearInputs">
                  <span class="fa fa-eraser mr-1"></span>条件クリア
                </button>
              </div>
              <div class="col-md-2 text-right">
                <button type="submit" class="btn btn-block btn-info" :disabled="isProcessing" @click="search">
                  <span class="fa fa-search mr-1"></span>検索
                </button>
              </div>
            </div>
            <div class="row form-actions pb-3" v-if="isTeresaStandard">
              <div class="col-md-6 text-right"></div>
              <div class="col-md-4 text-right">
                <button type="button" class="btn btn-block btn-secondary"
                  :disabled="isProcessing" @click="exportTeresaCsv">
                  <span class="fa fa-download mr-1"></span>テレッサ標準（予定 実績）の出力
                </button>
              </div>
              <div class="col-md-2 text-right"></div>
            </div>
          </div>
        </div>
        <div class="card-actions">
        </div>
      </div>
      <div class="card" v-if="page">
        <div class="row">
          <div class="col-12">
            <!-- Column -->
            <div class="card-body">
              <div class="dataTables_wrapper dt-bootstrap no-footer" v-if="page.data.length > 0">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="table-responsive">
                      <table id="report-table" class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th class="col-date sortable" :class="sortedClass('start_day,start_hhmm,end_day,end_hhmm')"
                              @click="sortBy('start_day,start_hhmm,end_day,end_hhmm')">
                              日時
                            </th>
                            <th class="col-staff sortable" :class="sortedClass('user_display_name')"
                              @click="sortBy('user_display_name')">
                              利用者
                            </th>
                            <th class="col-service-code  sortable" :class="sortedClass('service_type_id')"
                              @click="sortBy('service_type_id')">
                              サービスコード
                            </th>
                            <th class="col-status sortable" :class="sortedClass('plan_status_cd')"
                              @click="sortBy('plan_status_cd')">
                              状態
                            </th>
                            <th class="col-staff">スタッフ</th>
                            <th class="col-reported-at">報告:作業時間</th>
                            <th class="col-service-item">項目</th>
                            <th class="col-fare" v-if="isTaxi">運賃</th>
                            <th class="col-service-destination" v-if="isInstructionMode">行き先</th>
                            <th class="col-takeover" v-if="isInstructionMode">指示/申し送り</th>
                            <th class="col-actions"></th>
                            <th class="col-pdf">ファイル</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="plan in page.data" :key="plan.id">
                            <tr>
                              <td class="col-date" :rowspan="plan.reports.length + 1">
                                {{ dayString(plan.service.start_day, plan.service.start_day) }}<br>
                                {{ timeString(plan.service.start_hhmm, plan.service.end_hhmm) }}
                              </td>
                              <td class="col-user" :rowspan="plan.reports.length + 1">
                                {{ plan.user.display_name }}
                              </td>
                              <td class="col-service-type" :rowspan="plan.reports.length + 1">
                                <template v-if="plan.service.service_type_id">
                                  <p>{{ plan.service.service_type.display_name }}</p>
                                </template>
                                <template v-else>
                                  <p>(未設定)</p>
                                </template>
                                <template v-if="isSakura && plan.service.service_unique_code_id">
                                  <template v-if="plan.service.service_unique_code?.display_name !== undefined">
                                    <p>{{ plan.service.service_unique_code.display_name }}</p>
                                  </template>
                                  <template v-else>
                                    <p>(未設定)</p>
                                  </template>
                                </template>
                                <template
                                  v-else-if="(isTeresaStandard || (isNativeCode && !isSakura)) && plan.service.service_teresa_unique_code_id">
                                  <template v-if="plan.service.service_teresa_unique_code?.display_name !== undefined">
                                    <p>{{ plan.service.service_teresa_unique_code.display_name }}</p>
                                  </template>
                                  <template v-else>
                                    <p>(未設定)</p>
                                  </template>
                                </template>
                                <template v-else-if="plan.service.service_code_id">
                                  <p>{{ plan.service.service_code.display_name }}</p>
                                </template>
                                <template v-else>
                                  <p
                                    v-if="plan.service.service_type_id !== 1180 && plan.service.service_type_id !== 1182">
                                    (未設定)</p>
                                </template>
                              </td>
                              <td class="col-status" :rowspan="plan.reports.length + 1">
                                {{ constants.Code.PlanStatusList[plan.plan_status_cd] }}
                              </td>
                              <td class="col-staff">
                                <template v-if="plan.staff.length > 0">
                                  ■予定<br />
                                  <p class="m-0" v-for="staff in plan.staff" :key="'plan-staff-' + staff.id">
                                    {{ staff.display_name }}
                                  </p>
                                  {{ plan.reports.length }} / {{ plan.staff.length }}人
                                </template>
                                <template v-else>
                                  (未設定)
                                </template>
                              </td>
                              <td class="col-reported-at"></td>
                              <td class="col-service-item">
                                <div>
                                  <div>■ 予定</div>
                                  <span
                                    v-for="careItem in sortServiceItems(plan.service.service_type.care_item_sets, plan.service.service_items)"
                                    :key="careItem.id">
                                    {{ careItem.short_name }}/
                                  </span>
                                </div>
                              </td>

                              <td class="col-service-destination" v-if="isInstructionMode">
                                <template v-if="plan.service.destination">
                                  ■予定<br />
                                  <p>{{ plan.service.destination }}</p>
                                </template>
                                <template v-else>
                                  ■予定<br />
                                  <p>(未設定)</p>
                                </template>
                              </td>
                              <td class="col-fare" v-if="isTaxi" />
                              <td class="col-takeover" v-if="isInstructionMode">{{ plan.instruction }}</td>
                              <td v-bind:class='{ "bg-warning": plan.id == selectedPlanId }'>
                                <template v-if="!isApproved(plan)">
                                  <button class="btn btn-info btn-rounded" @click="editPlan(plan)"
                                    :disabled="isProcessing">
                                    プラン編集
                                  </button>
                                  <button class="btn btn-primary btn-rounded" @click="addReport(plan)"
                                    :disabled="isProcessing" v-if="plan.reports.length < plan.staff.length">
                                    報告追加
                                  </button>
                                </template>
                              </td>
                              <td></td>
                            </tr>
                            <tr v-for="report in plan.reports" :key="plan.id + '-' + report.id">
                              <td class="col-staff">
                                {{ report.staff.display_name }}
                              </td>
                              <td class="col-reported-at">
                                <p :class="{ 'has-diff': diffTime(plan, report) }">
                                  {{ formatDay(report.service.start_day) }}&nbsp;{{
                                    formatHHMM(report.service.start_hhmm)
                                  }}&nbsp;-&nbsp;{{ formatHHMM(report.service.end_hhmm) }}
                                </p>
                              </td>
                              <td class="col-service-item">
                                <div>
                                  <template
                                    v-if="plan.service.service_type_id === 1180 || plan.service.service_type_id === 1182">
                                    <div class="mb-2">サービス：{{
                                      report.service.service_type_input ?
                                        report.service.service_type_input :
                                        '(未入力)'
                                    }}
                                    </div>
                                  </template>
                                  <div
                                    :class="{ 'has-diff': diffServiceItems(plan.service.service_items, report.service.service_items) }">
                                    <span
                                      v-for="careItem in sortServiceItems(plan.service.service_type.care_item_sets, report.service.service_items)"
                                      :key="careItem.id">
                                      {{ careItem.short_name }}/
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td class="col-fare" v-if="isTaxi">
                                <div>
                                  <div style="float:left">運賃：</div>
                                  <div style="text-align:right">
                                    {{ formatAmount(report.service.fare) }} 円
                                  </div>
                                </div>
                                <div>
                                  <div style="float:left">現金：</div>
                                  <div style="text-align:right">
                                    {{ formatAmount(report.service.payment_cach) }} 円
                                  </div>
                                </div>
                                <div>
                                  <div style="float:left">引落：</div>
                                  <div style="text-align:right">
                                    {{ formatAmount(report.service.payment_unpaid) }} 円
                                  </div>
                                </div>
                                <div>
                                  <div style="float:left">ﾁｹｯﾄ：</div>
                                  <div style="text-align:right">
                                    {{ formatAmount(report.service.payment_ticket) }} 円
                                  </div>
                                </div>
                              </td>
                              <td class="col-service-destination" v-if="isInstructionMode"
                                :class="{ 'has-diff': diffDestination(plan.service.destination, report.service.destination) }">
                                <template v-if="report.service.destination">
                                  <p>{{ report.service.destination }}</p>
                                </template>
                                <template v-else>
                                  <p>(未入力)</p>
                                </template>
                              </td>

                              <td class="col-takeover" v-if="isInstructionMode">{{ report.takeover_comment }}</td>
                              <td v-bind:class='{ "bg-warning": report.id == selectedReportId }'>
                                <template v-if="report.approved_flag === 0">
                                  <button class="btn btn-secondary btn-rounded" v-if="!isSakura"
                                    @click="approved(plan, report, 1)" :disabled="isProcessing">承認
                                  </button>
                                  <button class="btn btn-info btn-rounded" :disabled="isProcessing"
                                    @click="editReport(plan, report)">編集
                                  </button>
                                </template>
                                <template v-else>
                                  <button class="btn btn-danger btn-rounded" @click="approved(plan, report, 0)"
                                    :disabled="isProcessing">取消
                                  </button>
                                </template>
                              </td>
                              <td class="col-pdf">
                                <div class="files-container">
                                  <div class="files">
                                    <a href="#" @click.prevent="openPdf(report)">
                                      <i class="pdf fa fa-file-pdf fa-2x"></i>
                                    </a>
                                  </div>
                                  <div class="files">
                                    <a :href="qrcodeUrl(report)" v-if="report.qrcode_id" target="_blank">
                                      <img :src="qrcodeUrl(report)" class="qr" />
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <pagination :page="page" v-if="page && page.data.length > 0" @change="changePage" />
              </div>
              <div v-else>
                <div class="alert alert-warning">
                  <p><i class="fa fa-info-circle p-r-10" />該当するデータが見つかりませんでした。</p>

                  <p>検索のヒント</p>
                  <ul>
                    <li>
                      検索条件を変更してみてください。
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
    </div>

    <report-editor v-if="showReportEditModal" v-model="showReportEditModal" :plan="planToEdit" :report="reportToEdit"
      @update:modelValue="val => showReportEditModal = val" @close="onReportEditModalClosed"
      @cancel="onReportEditModalCancel" />

    <plan-edit-modal v-if="showPlanEditModal" v-model="showPlanEditModal" :office-id="inputs.targetOfficeId"
      :staffs="staffs || []" :users="users || []" :plan="planToEdit" :editable="true"
      @update:modelValue="val => showPlanEditModal = val" @close="onPlanEditModalClosed"
      @cancel="onPlanEditModalCancel" />
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, computed } from 'vue'
import _ from 'underscore'
import dayjs from 'dayjs'
import api from '@/libs/Api'
import ApiError from '@/libs/ApiError'
import utils from '@/libs/Utils'
import SelectOffice from '@/components/SelectOffice.vue'
import Pagination from '@/components/Pagination.vue'
import Constants from '@/constants'
import ReportEditor from '@/components/ReportEditor.vue'
import SelectServiceType from '@/components/SelectServiceType.vue'
import SelectServiceCode from '@/components/SelectServiceCode.vue'
import SelectServiceUniqueCode from '@/components/SelectServiceUniqueCode.vue'
import SelectServiceTeresaUniqueCode from '@/components/SelectServiceTeresaUniqueCode'
import repos from '@/libs/Repository'
import PlanEditModal from '@/components/PlanEditModal.vue'
import 'dayjs/locale/ja'
import { useStore } from 'vuex'
import { useExecutor } from '@/libs/Executor'
import { useToast } from 'vue-toastification'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'

const store = useStore()
const { exec } = useExecutor()
dayjs.locale('ja')

const isProcessing = ref(false)
const isTaxi = ref(false)
const isF1 = ref(false)
const isKaigoNoMori = ref(false)
const isSakura = ref(false)
const isNativeCode = ref(false)
const isTeresaStandard = ref(false)
const sort = reactive({
  key: '',
  isAsc: false
})
const users = ref([])
const staffs = ref([])
const inputs = reactive({
  targetOfficeId: null,
  startDayFrom: null,
  startDayTo: null,
  serviceTypeId: null,
  serviceCodeId: null,
  serviceUniqueCodeId: null,
  serviceTeresaUniqueCodeId: null,
  userDisplayName: null,
  staffDisplayName: null,
  mode: 2
})
const page = ref(null)
const constants = ref(Constants)
const selectedPlanId = ref(null)
const selectedReportId = ref(null)
const serviceTypeIdUniqueCode = ref(null)
const showPlanEditModal = ref(false)
const planToEdit = ref(null)
const showReportEditModal = ref(false)
const reportToEdit = ref(null)

const profile = computed(() => {
  return store.state.session.profile
})

const isApproved = computed(() => {
  return function (plan) {
    return plan.plan_status_cd === Constants.Code.PlanStatus.APPROVED
  }
})

const isInstructionMode = computed(() => {
  return inputs.mode === 0 || inputs.mode === 1
})

onMounted(async () => {
  const params = repos.getReportSearchParams()
  if (params) {
    Object.keys(params).forEach(key => {
      inputs[key] = params[key]
    })
  } else {
    await clearInputs()
  }

  isTaxi.value = (Constants.FunctionMask.TAXI & profile.value.site.function_mask) === Constants.FunctionMask.TAXI
  isF1.value = (Constants.FunctionMask.F1 & profile.value.site.function_mask) === Constants.FunctionMask.F1
  isSakura.value = (Constants.FunctionMask.SAKURA & profile.value.site.function_mask) === Constants.FunctionMask.SAKURA
  isKaigoNoMori.value = (Constants.FunctionMask.KaigoNoMori & profile.value.site.function_mask) === Constants.FunctionMask.KaigoNoMori
  isNativeCode.value = (Constants.FunctionMask.NATIVE_CODE & profile.value.site.function_mask) === Constants.FunctionMask.NATIVE_CODE
  isTeresaStandard.value = (Constants.FunctionMask.TeresaStandard & profile.value.site.function_mask) === Constants.FunctionMask.TeresaStandard

  serviceTypeIdUniqueCode.value = Constants.Code.ServiceType.UNIQUE_CODE
})

const clearInputs = async () => {
  repos.setReportSearchParams(null)
  inputs.targetOfficeId = null
  inputs.startDayFrom = null
  inputs.startDayTo = null
  inputs.serviceTypeId = null
  inputs.serviceTypeGroupId = null
  inputs.serviceCodeId = null
  inputs.userDisplayName = null
  inputs.staffDisplayName = null
  inputs.startDayFrom = dayjs().format('YYYY-MM-DD')
  inputs.startDayTo = dayjs().format('YYYY-MM-DD')

  if (isTeresaStandard.value || (isNativeCode.value && !isSakura.value)) {
    inputs.serviceTeresaUniqueCodeId = null
  }
  await searchImpl()
}

const searchImpl = async (pageParam = 1) => {
  exec(async () => {
    isProcessing.value = true
    users.value = await api.getUser(Constants.QUERY_MODE_TRIM_GET, null, inputs.targetOfficeId)
    staffs.value = await api.getStaffs(Constants.QUERY_MODE_TRIM_GET, null, inputs.targetOfficeId)
    const query = createQuery(Constants.QUERY_MODE_PAGING, pageParam)
    const res = await api.getPlans(query)
    repos.setReportSearchParams(inputs)
    page.value = res
    isProcessing.value = false
    return Promise.resolve()
  })
    .catch(() => {
    })
}

const search = async () => {
  selectedPlanId.value = null
  selectedReportId.value = null
  sort.key = 'start_day,start_hhmm,end_day,end_hhmm'
  sort.isAsc = true
  searchImpl()
}

const createQuery = (mode, page) => {
  const startDayFrom = (inputs.startDayFrom) ? inputs.startDayFrom.replace(/-/g, '') : null
  const startDayTo = (inputs.startDayTo) ? inputs.startDayTo.replace(/-/g, '') : null
  const officeId = (inputs.targetOfficeId) || null
  const serviceTypeId = (inputs.serviceTypeId) || null
  const serviceTypeGroupId = (inputs.serviceTypeGroupId) || null
  const serviceCodeId = (inputs.serviceCodeId) || null
  const userDisplayName = (inputs.userDisplayName) || null
  const staffDisplayName = (inputs.staffDisplayName) || null
  const query = {
    mode: mode,
    page: page,
    sort: sort.key,
    is_asc: sort.isAsc,
    office_id: officeId,
    start_day_from: startDayFrom,
    start_day_to: startDayTo,
    service_type_id: serviceTypeId,
    service_type_group_id: serviceTypeGroupId,
    service_code_id: serviceCodeId,
    user_display_name: userDisplayName,
    staff_display_name: staffDisplayName
  }

  if (isTeresaStandard.value || (isNativeCode.value && !isSakura.value)) {
    const serviceTeresaUniqueCodeId = inputs.serviceTeresaUniqueCodeId || null
    query.service_teresa_unique_code_id = serviceTeresaUniqueCodeId
  }

  return query
}

const sortedClass = (key) => {
  return sort.key === key ? `sorted ${sort.isAsc ? 'asc' : 'desc'}` : ''
}

const sortBy = (key) => {
  sort.isAsc = sort.key === key ? !sort.isAsc : false
  sort.key = key

  if (page.value) {
    searchImpl(page.value.current_page)
  } else {
    searchImpl()
  }
}

const dayString = (day, date) => {
  return utils.formatDay(day) + ' ' + dayjs(date).format('(ddd)')
}

const timeString = (startHhmm, endHhmm) => {
  return formatHHMM(startHhmm) + ' - ' + formatHHMM(endHhmm)
}

const formatHHMM = (hhmm) => {
  if (!hhmm) return '(未設定)'
  return hhmm.substr(0, 2) + ':' + hhmm.substr(2, 2)
}

const formatDay = (day) => {
  return utils.formatDay(day)
}

const formatAmount = (value) => {
  if (value == null || value === '') return '0'
  const num = Number(value)
  if (Number.isNaN(num)) return '0'
  return num.toLocaleString()
}

const sortServiceItems = (careItemSets, serviceItems) => {
  let result = []
  careItemSets.forEach(careItemSet => {
    careItemSet.care_item_groups.forEach(careItemGroup => {
      careItemGroup.care_items.forEach(careItem => {
        if (_.find(serviceItems, serviceItem => careItem.id === serviceItem.care_item_id)) {
          result.push(careItem)
        }
      })
    })
  })
  return result
}

const diffTime = (plan, report) => {
  if (plan.service.start_day !== report.service.start_day) {
    return true
  }
  if (plan.service.start_hhmm !== report.service.start_hhmm) {
    return true
  }
  if (plan.service.end_hhmm !== report.service.end_hhmm) {
    return true
  }
  return false
}

const diffServiceItems = (planServiceItems, reportServiceItems) => {
  let hasDiff = false

  planServiceItems.forEach(planServiceItem => {
    if (!_.find(reportServiceItems, reportServiceItem => reportServiceItem.care_item_id === planServiceItem.care_item_id)) {
      hasDiff = true
    }
  })
  reportServiceItems.forEach(reportServiceItem => {
    if (!_.find(planServiceItems, planServiceItem => planServiceItem.care_item_id === reportServiceItem.care_item_id)) {
      hasDiff = true
    }
  })

  return hasDiff
}

const diffDestination = (planDestination, reportDestination) => {
  return planDestination !== reportDestination
}

const exportTeresaCsv = async () => {
  exec(async () => {
    const query = createQuery(null, null)
    const res = await api.exportTeresaStandardPlans(query)
    saveCsvFile(res.data, 'report')
    isProcessing.value = false
  }).catch((error) => {
    console.error('Error exporting Teresa CSV:', error)
  })
}

const downloadCsv = async () => {
  exec(async () => {
    const query = createQuery(null, null)
    const res = await api.exportPlans(query)
    saveCsvFile(res.data, 'report')
    isProcessing.value = false
  }).catch(() => {
  })
}

const downloadKaigoNoMoriCsv = async () => {
  exec(async () => {
    if (!inputs.targetOfficeId) {
      alert('事業所を選択してください。')
      return Promise.resolve()
    }
    const query = createQuery(null, null)
    let res = null
    try {
      res = await api.exportKaigoNoMoriReports(query)
    } catch (error) {
      if (ApiError.isNotFound(error)) {
        alert('該当するデータが登録されていません。')
        return Promise.resolve()
      }
      return Promise.reject(error)
    }
    saveCsvFile(res, 'report')
    isProcessing.value = false
    return Promise.resolve()
  })
}

const downloadF1Csv = async () => {
  exec(async () => {
    if (!inputs.targetOfficeId) {
      alert('事業所を選択してください。')
      return Promise.resolve()
    }
    const query = createQuery(null, null)
    let res = null
    try {
      res = await api.exportF1Plans(query)
    } catch (error) {
      if (ApiError.isNotFound(error)) {
        alert('該当するデータが登録されていません。')
        return Promise.resolve()
      }
      return Promise.reject(error)
    }
    saveCsvFile(res, 'f1_report')
    isProcessing.value = false
    return Promise.resolve()
  })
}

const saveCsvFile = (res, filename) => {
  // CSVデータ取得 - BOM 付与
  const blob = new Blob([res], { type: 'text/csv' })

  filename += '_' + dayjs(Date.now()).format('YYYYMMDD_HHmmss') + '.csv'

  if (window.navigator.msSaveBlob) {
    // IE11 ( msSaveBlog が有効なら)
    window.navigator.msSaveBlob(blob, filename)
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    link.click()
    window.URL.revokeObjectURL(url)
  }
}

const editPlan = (plan) => {
  if (isProcessing.value) return
  selectedPlanId.value = plan.id
  selectedReportId.value = null
  planToEdit.value = plan
  reportToEdit.value = null
  showPlanEditModal.value = true
}

const addReport = (plan) => {
  selectedPlanId.value = plan.id
  selectedReportId.value = null
  planToEdit.value = plan
  reportToEdit.value = null
  showReportEditModal.value = true
}

const toast = useToast()

const approved = async (plan, report, approved = true) => {
  selectedPlanId.value = null
  selectedReportId.value = report.id

  exec(async () => {
    isProcessing.value = true
    const res = await api.updateReport({
      id: report.id,
      approved_flag: approved
    })
    report.approved_flag = approved
    plan.plan_status_cd = res.plan.plan_status_cd
    if (report.approved_flag) {
      toast.success('承認しました。')
    } else {
      toast.error('取り消しました。')
    }

    isProcessing.value = false
    return Promise.resolve()
  })
    .catch(() => {
    })
}

const editReport = (plan, report) => {
  selectedPlanId.value = null
  selectedReportId.value = report.id
  reportToEdit.value = report
  planToEdit.value = plan
  showReportEditModal.value = true
}

const openPdf = (report) => {
  exec(async () => {
    isProcessing.value = true
    const res = await api.getReportPdfUrl(report.id)
    window.open(res.url, 'report_' + report.id)
    isProcessing.value = false
  })
    .catch(() => {
    })
}

const qrcodeUrl = (report) => {
  if (!report.qrcode) return ''
  return process.env.VUE_APP_FILE_URL + report.qrcode.filename
}

const changePage = async (pageParams) => {
  await searchImpl(pageParams)
}

const onPlanEditModalClosed = (updated) => {
  if (!updated) return
  if (page.value) {
    searchImpl(page.value.current_page)
  } else {
    searchImpl()
  }
}

const onReportEditModalClosed = (updated) => {
  if (!updated) return
  if (page.value) {
    searchImpl(page.value.current_page)
  } else {
    searchImpl()
  }
}

const onPlanEditModalCancel = () => {
}

const onReportEditModalCancel = () => {
}

</script>

<style lang="scss" scoped>
table {
  th {
    &.sorted {
      &.asc::after {
        display: inline-block;
        content: '▲';
      }

      &.desc::after {
        display: inline-block;
        content: '▼';
      }
    }
  }

  .sortable {
    cursor: pointer;
    text-decoration: underline;
  }
}

#report-table {
  width: 1300px;
}

td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

tbody .active {
  background-color: yellow;
}

.col-office {
  width: 130px;
  max-width: 130px;
}

.col-date {
  width: 200px;
  max-width: 150px;
}

td.col-takeover {
  width: 200px;
  max-width: 200px;
  white-space: pre-wrap;
}

.col-hhmm {
  width: 140px;
  max-width: 140px;
}

.col-status {
  width: 100px;
  max-width: 100px;
  text-align: center;
}

.col-reported-at {
  width: 180px;
  max-width: 180px;
  text-align: center;
}

.col-user {
  width: 130px;
  max-width: 130px;
}

.col-staff {
  width: 130px;
  max-width: 130px;
}

.col-service-type {
  text-align: center;
}

.col-service-code {
  width: 170px;
  max-width: 170px;
  text-align: center;
}

.col-service-item {
  width: 250px;
  max-width: 250px;
  white-space: normal;
}

.col-service-destination {
  width: 250px;
  max-width: 250px;
  white-space: normal;
}

.col-fare {
  width: 170px;
  max-width: 170px;
}

.col-actions {
  width: 170px;
  max-width: 170px;
}

.col-pdf {
  width: 90px;
  max-width: 90px;
}

.has-diff {
  color: red;
}

.pdf {
  color: black;
  padding-top: 2px;
  padding-right: 2px;
}

.qr {
  width: 30px;
  height: 30px;
}

.files {
  float: left;
}

td .btn {
  padding: 3px;
  margin: 0 8px;
}
</style>
